import React from "react";
import { get } from "lodash";
import { iconStyles } from "../constant";
import { LabelIcon, LabelText, LabelDot } from "../styled-components";

export interface LabelIconProps {
  raceStatus: string;
  label: string;
  qaLabel?: string;
  isDesktop: boolean;
}

const LabelIconComp = ({
  raceStatus,
  label,
  qaLabel = "myBets-label-icon",
  isDesktop
}: LabelIconProps) => {
  const iconProps = {
    icon: get(iconStyles, `${raceStatus}.icon`),
    viewBoxSize: 16,
    size: 16,
    color: get(iconStyles, `${raceStatus}.background`),
    stroke: get(iconStyles, `${raceStatus}.iconColor`)
  };

  if (isDesktop && (raceStatus === "open" || raceStatus === "raceOff")) {
    return <LabelText boldText={raceStatus === "raceOff"}>{label}</LabelText>;
  }

  return iconProps.icon ? (
    <LabelIcon {...iconProps} data-qa-label={qaLabel} />
  ) : (
    <LabelDot raceStatus={raceStatus} data-qa-label={qaLabel} />
  );
};

export default LabelIconComp;
